<template>
  <el-dialog title="新增商机" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false" width="40%">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="135px">
      <el-card shadow="never" class="el-card-simple">
        <div slot="header">
          <span>客户信息</span>
        </div>
        <el-form-item label="客户名称:" prop="customerId">
          <customer-select ref="customerSelectRef" :form-param="data" :disabled="fromCustomer" :param-list="customerList" @change="customerChange"></customer-select>
          <span v-if="!fromCustomer">如果无客户信息，请<el-button type="text" @click="skipCustomerList">前往添加</el-button></span>
        </el-form-item>
      </el-card>
      <el-card shadow="never" class="el-card-simple">
        <div slot="header">
          <span>联系人信息</span>
        </div>
        <el-form-item label="联系人:" prop="contactId">
          <el-select v-model="data.contactId" placeholder="请选择联系人" clearable style="width:100%">
            <el-option v-for="dict in contactList" :key="dict.id" :label="dict.name" :value="dict.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="角色:" prop="role">
          <el-select v-model="data.role" placeholder="请选择" clearable style="width:100%">
            <el-option v-for="dict in roleOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
          </el-select>
        </el-form-item>
      </el-card>
      <el-card shadow="never" class="el-card-simple">
        <div slot="header">
          <span>商机信息</span>
        </div>
        <el-form-item label="商机名称:" prop="businessName">
          <el-input v-model="data.businessName" :maxlength="32" placeholder="请输入商机名称" clearable/>
        </el-form-item>
        <el-form-item label="商机级别:" prop="businessLevel">
          <el-select v-model="data.businessLevel" placeholder="请选择商机级别" clearable style="width:100%">
            <el-option v-for="stage in businessLevelOptions" :key="stage.dictValue" :label="stage.dictLabel" :value="stage.dictValue"/>
          </el-select>
          <el-popover placement="right" title="商机级别" width="410" trigger="hover">
            <div>
              A类商机：需满足3个条件，搞定人、搞定事、1个月内签约。<br>
              B类商机：需满足3个条件，搞定人、搞定事、2个月内签约。<br>
              C类商机：人和事都没搞定。<br>
              D类商机：商机项目待定，且人和事看未搞定。
            </div>
              <el-button slot="reference" type="text">商机级别说明</el-button>
          </el-popover>
        </el-form-item>
        <el-form-item label="商机来源:" prop="businessSource">
          <el-select v-model="data.businessSource" placeholder="请选择商机来源" allow-create filterable clearable style="width:100%">
            <el-option v-for="dict in businessSourceOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
          </el-select>
        </el-form-item>
        <el-form-item label="商机规模:" prop="businessScale">
          <el-select v-model="data.businessScale" placeholder="请选择商机规模" clearable style="width:100%">
            <el-option v-for="item in businessScaleOptions" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"/>
          </el-select>
          <el-popover placement="right" title="商机规模（金额）" width="200" trigger="hover">
            <div>
              甲：300万及以上<br>
              乙：100万-300万<br>
              丙：50万-100万<br>
              丁：50万以下
            </div>
            <el-button slot="reference" type="text">商机规模说明</el-button>
          </el-popover>
        </el-form-item>
        <el-form-item label="商机负责人:" prop="assignUserId">
          <UserSelect v-model="data.assignUserId" placeholder="请选择商机负责人"></UserSelect>
        </el-form-item>
        <el-form-item label="采购需求:" prop="requirements">
          <el-select v-model="data.requirements" placeholder="请选择采购需求" clearable multiple style="width:100%">
            <el-option v-for="item in requirementOptions" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="项目类型:" prop="projectType">
          <el-select v-model="data.projectType" placeholder="请选择项目类型" clearable style="width:100%">
            <el-option v-for="stage in projectTypeOptions" :key="stage.dictValue" :label="stage.dictLabel" :value="stage.dictValue"/>
          </el-select>
          <el-popover
            v-if="data.projectType==1"
            placement="right"
            title="难降解工业废水类别说明"
            width="400"
            trigger="hover">
            <span>医疗废水；制药废水；化工废水；垃圾渗滤液；印染废水；实验室废水；食品废水；养殖废水；屠宰废水；餐厨废水；饮料废水；电子废水；光伏废水；乳液废水</span>
            <el-button v-if="data.projectType==1" slot="reference" type="text">难降解工业废水类别说明</el-button>
          </el-popover>
        </el-form-item>
        <el-form-item label="项目区域:" prop="area">
          <el-cascader v-model="data.area" :options="areaOptions" :props="{ checkStrictly: true }" filterable clearable style="width:100%"></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址:" prop="address">
          <el-input type="textarea" v-model="data.address" :maxlength="200" show-word-limit placeholder="请输入详细地址" clearable/>
        </el-form-item>
        <el-form-item label="预计成交金额:" prop="estimateDealAmount">
          <el-input-number v-model="data.estimateDealAmount" placeholder="请输入预计成交金额" :min="0" :max="999999999" :precision="2" :controls="false" clearable class="crm-input-number-wrap"/>
          <span class="el-input__suffix">元</span>
        </el-form-item>
        <el-form-item label="预计成交时间:" prop="estimateDealDate">
          <el-date-picker v-model="data.estimateDealDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width:100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}" :maxlength="1000" show-word-limit v-model="data.remark" placeholder="请输入1000字以内备注" clearable/>
        </el-form-item>
      </el-card>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import UserSelect from "@/views/crm/components/userSelect";
import {addBusiness, businessNameCheck} from "@/api/crm/business";
import {listAllLevelArea} from '@/api/crm/area'
import {transferCascaderOptionsForProvince} from '@/utils'
import {queryProductTypeList2} from "@/api/crm/contract";
import {mapState} from "vuex";
import {queryContactByCustomerId} from "@/api/crm/contact";
import customerSelect from "@/views/crm/components/customerSelect";

export default {
  name: "AddBusinessDialog",
  props: {
  },
  data() {
    return {
      visible: false,
      fromCustomer: false,
      customerList: [],
      contactList: [],
      businessLevelOptions: [],
      businessSourceOptions: [],
      businessScaleOptions: [],
      requirementOptions: [],
      projectTypeOptions: [],
      areaOptions: [],
      roleOptions: [], // 角色列表
      rules: {
        customerId: [
          {required: true, type: 'number', message: '请选择客户', trigger: 'change'}
        ],
        contactId: [
          {required: true, type: 'number', message: '请选择联系人', trigger: 'change'}
        ],
        role: [
          {required: true, message: '请选择联系人角色', trigger: 'change'}
        ],
        businessName: [
          {required: true, validator: this.checkBusiness, trigger: 'change'},
          {max: 32, message: '长度过长', trigger: 'change'}
        ],
        businessLevel: [
          {required: true, message: '请选择商机级别', trigger: 'change'}
        ],
        businessSource: [
          {required: true, message: '请选择商机来源', trigger: 'change'}
        ],
        businessScale: [
          {required: true, message: '请选择商机规模', trigger: 'change'}
        ],
        assignUserId: [
          {required: true, message: '请选择商机负责人', trigger: 'change'}
        ],
        requirements: [
          {required: true, message: '请选择采购需求', trigger: 'change'}
        ],
        projectType: [
          {required: true, message: '请选择项目类型', trigger: 'change'}
        ],
        estimateDealAmount: [
          {required: true, type:'number', message: '请输入预计成交金额', trigger: 'blur'}
        ],
        estimateDealDate: [
          {required: true, message: '请选择预计成交时间', trigger: 'change'}
        ]
      },
      data: {
        businessName: null,
        customerId: null,
        contactId: null,
        role: null,
        businessSource: null,
        businessScale: null,
        estimateDealAmount: undefined,
        estimateDealDate: null,
        assignUserId: null,
        businessLevel: null,
        requirements: [],
        projectType: null,
        area: [],
        address: null,
        provinceCode: null,
        cityCode: null,
        regionCode: null,
        remark: null
      }
    };
  },
  created() {
    this.getDicts("business_level").then(response => {
      this.businessLevelOptions = response.data;
    });
    this.getDicts("common_source").then(response => {
      this.businessSourceOptions = response.data;
    });
    this.getDicts("business_scale").then(response => {
      this.businessScaleOptions = response.data;
    });
    queryProductTypeList2({}).then(response => {
        this.requirementOptions = response.data || [];
    })
    this.getDicts("project_type").then(response => {
      this.projectTypeOptions = response.data;
    });
    this.getDicts("business_contact_role").then(response => {
      this.roleOptions = response.data;
    });
    listAllLevelArea({ level: 3 }).then(response => {
      this.areaOptions = transferCascaderOptionsForProvince(response.data);
    });
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  components: {
    UserSelect,
    customerSelect
  },
  watch: {
    visible (val) {
      if (!val) {
        this.resetForm("addForm");
      }
    }
  },
  methods: {
    open (type, id, name) {
      if (type == 'customerId') {
        this.data.customerId = id
        this.customerList = [{id: id, customerName: name}]
        this.fromCustomer = true
        queryContactByCustomerId({customerId: id}).then(response => {
          this.contactList = response.data
        })
      }
      this.visible = true
      this.data.assignUserId = this.currentUserId
    },
    checkBusiness (rule, value, callback) {
      // 必填
      if (!value) {
        callback(new Error("请输入商机名称"))
      } else if (this.data.customerId) {
        // 选了客户才需要去校验，所以在选客户时要手动触发校验
        businessNameCheck(
          {
            businessName: value,
            customerId: this.data.customerId
          }
        ).then( response => {
          if (response.data && response.data.id) {
            callback(new Error("商机名称已存在，请重新输入"))
          } else {
            callback()
          }
        }).catch(error => {
          callback()
        })
      } else {
        callback()
      }
    },
    skipCustomerList() {
      this.$router.push("/crm/customer/manage");
    },
    confirm () {
      this.$refs['addForm'].validate((valid) => {
        this.data.provinceCode = this.data.area && this.data.area.length > 0 ? this.data.area[0] : null
        this.data.cityCode = this.data.area && this.data.area.length > 1 ? this.data.area[1] : null
        this.data.regionCode = this.data.area && this.data.area.length > 2 ? this.data.area[2] : null
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          addBusiness(this.data).then(response => {
            this.$emit('success')
            this.visible = false
            loading.close();
            this.msgSuccess("商机新增成功");
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    },
    customerChange() {
      let param = {
        customerId: this.data.customerId
      }
      this.data.contactId = null
      queryContactByCustomerId(param).then(response => {
        this.contactList = response.data
      }).catch(error => {
      })
    },
  }
};
</script>
